import React, { ReactElement, useEffect } from 'react'
import Divider from '../Divider'
import WalletsOverview from '@/components/wallets/WalletsOverview'

const WalletsPanel = (): ReactElement => {
    useEffect(() => {
        window.location.hash = `#wallets`
    }, [])

    return (
        <div className="panel">
            <Divider />
            <WalletsOverview />
        </div>
    )
}

export default WalletsPanel
